<template>
  <h3 class="text-center font-semibold text-gray-700">Descarte</h3>
  <div id="chart2">
    <apexchart
      type="radialBar"
      :options="options"
      :series="series"
      width="100%"
      height="250"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
export default {
  name: "PRODReportingProcessPercentageDiscard",
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      options: {
        chart: {
          type: "radialBar"
        },
        plotOptions: {
          radialBar: {
            hollow: { size: 55 },
            dataLabels: {
              name: {
                offsetY: 100,
                fontSize: "16px"
              },
              value: {
                offsetY: -5,
                color: "#CC3333",
                formatter: val => {
                  return parseInt(val) + "%";
                },
                fontSize: "32px"
              }
            }
          }
        },
        colors: ["#CC3333"],
        labels: ["% descarte"]
      }
    };
  },
  props: {
    series: { required: true }
  }
};
</script>
